import { FormGroupState } from "ngrx-forms";

export interface IInitialDataState {
    form: FormGroupState<InitialDataModel>;
    dataSaved:boolean;
}

export class InitialDataModel {
    firstName: string = '';
    lastName: string = '';
    email: string = '';
    token: string = '';
    journeyId:number = 0;
}